import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationPreferenceStore = defineStore('notification-preferences', () => {
  const roomsNotificationAccess = ref<Map<string, boolean>>(new Map<string, boolean>())

  const getAccessByRoomId = (roomId: string) => {
    return roomsNotificationAccess.value.get(roomId) ?? false
  }

  const addRoomsNotificationAccess = (roomId: string, disabled: boolean) => {
    roomsNotificationAccess.value.set(roomId, disabled)
  }

  return {
    roomsNotificationAccess,
    getAccessByRoomId,
    addRoomsNotificationAccess,
  }
})
